const extConstants = {
	FEATURE: "@approval",
};

export default extConstants;